import { useState, useEffect } from 'react';

const STATS = [
  { label: '今日更新', value: '128条', icon: 'ri-flashlight-line' },
  { label: '话题覆盖', value: '50+分类', icon: 'ri-stack-line' },
  { label: '7×24追踪', value: '全天候', icon: 'ri-timer-line' },
];

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div
            className={`flex-1 w-full transition-all duration-700 ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span className="whitespace-nowrap">全网热瓜实时追踪</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              52吃瓜网
              <span className="block text-primary-600 md:inline md:ml-2">— 你的在线吃瓜第一站</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-2 font-medium">
              📰 海量八卦 · 每日更新 · 想吃就吃
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mb-6">
              52吃瓜网汇聚全网最新娱乐八卦与热门吃瓜话题，覆盖明星动态、综艺影视、网红趣事等多元领域。每日滚动更新海量资讯，让你不错过任何一个瓜。无论是追星吃瓜还是消遣解闷，这里都是你的一站式吃瓜乐园——吃得快、吃得全、吃得爽。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-7">
              {STATS.map((s) => (
                <div key={s.label} className="flex items-center gap-1.5 text-sm text-foreground-600">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${s.icon} text-sm`}></i>
                  </span>
                  <span className="font-medium text-foreground-800">{s.value}</span>
                  <span className="text-foreground-500">{s.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo('#index');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始吃瓜
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo('#updates');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-300 text-primary-700 font-medium text-sm rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-newspaper-line"></i>
                查看最新
              </a>
            </div>
          </div>

          <div
            className={`flex-1 w-full transition-all duration-700 delay-200 ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 via-accent-200/30 to-primary-100/40 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20vibrant%20abstract%20composition%20with%20overlapping%20geometric%20shapes%20in%20coral%20pink%20and%20warm%20golden%20tones%2C%20playful%20magazine%20collage%20style%20with%20speech%20bubbles%20and%20stars%2C%20digital%20art%2C%20clean%20background%2C%20modern%20editorial%20design%2C%20soft%20gradients%2C%20energetic%20but%20refined%20aesthetic&width=700&height=500&seq=hero-main-2026-x1&orientation=landscape"
                alt="52吃瓜网 - 娱乐八卦资讯平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}